<script setup>
import { useAuthStore } from '@/store/auth'
import { defineEmits, onBeforeUnmount, onMounted, ref } from 'vue'

const emits = defineEmits(['closeDropdown'])

const authStore = useAuthStore()

const userId = ref(0)
const dropdownCard = ref(null)

const handleLogout = async () => {
    emits('closeDropdown')
    await authStore.logout()
    await authStore.remove_token()
}

const handleClickOutside = (event) => {
    if (
        !dropdownCard.value.contains(event.target) &&
        !event.target.classList.contains('user-avatar')
    ) {
        emits('closeDropdown')
    }
}

onMounted(() => {
    userId.value = authStore.id
    document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside)
})
</script>

<template>
    <div
        ref="dropdownCard"
        class="dropdown-card"
    >
        <ul>
            <li>
                <router-link
                    :to="`/personalities/${userId}`"
                    @click="
                        () => {
                            emits('closeDropdown')
                        }
                    "
                >
                    Профиль
                </router-link>
            </li>
            <li @click="handleLogout">Выйти</li>
        </ul>
    </div>
</template>

<style lang="scss" scoped>
.dropdown-card {
    margin-top: 15px;
    width: auto;
    background: #fff;
    border-radius: 4px;
    position: absolute;
    padding: 20px 25px;
    text-align: left;
    width: 200px;
    box-shadow:
        0 0 13.8912px 0 rgba(109, 109, 109, 0.01),
        0 0 28.76296px 0 rgba(109, 109, 109, 0.02),
        0 0 57.3625px 0 rgba(109, 109, 109, 0.03),
        0 0 112.43703px 0 rgba(109, 109, 109, 0.03),
        0 0 206.7338px 0 rgba(109, 109, 109, 0.04),
        0 0 353px 0 rgba(109, 109, 109, 0.05);
}

ul {
    list-style: none;
    font-size: 20px;
    line-height: 28px;
    display: flex;
    flex-direction: column;
    gap: 15px;

    li {
        cursor: pointer;

        &:hover {
            color: #0635ac;
            transition: color 0.2s;
        }
    }
}

a {
    text-decoration: none;
    color: unset;
}
</style>
